module.exports = __webpack_public_path__ + "media/images/vp/samples/11-c50399b2164d9c40ac948fc7b27c6251.jpg";